module.exports = __webpack_public_path__ + "static/media/pay-by-koomipay.f5873a1c.png";